export default __webpack_public_path__ + "static/TTCommons-Light-e9b8371d492e5fdac8beddacaf6f9134.ttf";